import React, { useEffect, useMemo } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import * as uiHelpers from "../RecapitulationReportUIHelpers";

import {
  currencyFormatter,
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../../_metronic/_partials/controls";
import { toMonthName } from "../../../../../config/helper";
import moment from "moment";

const RecapitulationReportTable = ({
  entities,
  totalCount,
  listLoading,
  queryParams = {},
  setQueryParams,
  openEditRecapitulationReportPage,
  setCurrentItem,
  setOpenModal
}) => {
  // Table columns
  const columns = [
    {
      dataField: "organization_name",
      text: "Nama Yayasan",
      sort: true
    },
    {
      dataField: "trx_date",
      text: "Tanggal Transaksi",
      sort: true,
    },
    {
      dataField: "type",
      text: "Jenis Dana",
      sort: true,
    },
    {
      dataField: "program_name",
      text: "Program",
      sort: true
    },
    {
      dataField: "project_name",
      text: "Project",
      sort: true
    },
    {
      headerClasses: "text-right",
      classes: "text-right",
      dataField: "total_amount",
      text: "Nominal",
      sort: true,
      formatter: cell => {
        return <span>{currencyFormatter(cell)}</span>;
      }
    },
    // {
    //   dataField: "action",
    //   text: "Actions",
    //   formatter: columnFormatters.ActionsColumnFormatter,
    //   formatExtraData: {
    //     openEditConsolidationReportPage: openEditConsolidationReportPage,
    //     setCurrentItem,
    //     setOpenModal
    //   },
    //   classes: "text-right pr-0",
    //   headerClasses: "text-right pr-3",
    //   style: {
    //     minWidth: "100px"
    //   }
    // }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(setQueryParams)}
                // selectRow={getSelectRow({
                //   entities,
                //   ids: productsUIProps.ids,
                //   setIds: productsUIProps.setIds,
                // })}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default RecapitulationReportTable;
